import { useQuery } from "@tanstack/react-query";
import { Charge } from "../../models/Charge";
import { getCharges } from "../../repositories/ChargeRepository";

export const useChargeByIdQuery = (chargeId: number | null) => {
  return useQuery({
    queryKey: ["charge", chargeId],
    queryFn: async ({ signal }) => {
      const resp = await getCharges({ chargeId }, signal);
      if (resp.ok) {
        const rows = (resp.data?.tables?.[0]?.rows ?? []) as Charge[];
        return rows[0] ?? null;
      }
      throw new Error(resp.message);
    },
    enabled: chargeId !== null,
  });
};
